import { ChecklistItem } from '../types/ChecklistTypes';
import { ChecklistSection as Section } from '../types/generated/checklist-models';

/**
 * The rows shown and counted toward progress, and `getVisibleSectionItems` is the single rule other writers mirror.
 * Prototypes and orphan occurrences (stale offline data) are excluded, and callers warn about orphans.
 */
export function getVisibleSectionItems(
  items: ChecklistItem[]
): ChecklistItem[] {
  const prototypeGroupIds = new Set<string>();
  const occurrencesByGroup = new Map<string, ChecklistItem[]>();
  const regular: ChecklistItem[] = [];

  for (const item of items) {
    if (item.isRepeatablePrototype) {
      const groupId = item.repeatableGroupId ?? item.id;
      prototypeGroupIds.add(groupId);
      continue;
    }

    if (item.repeatableGroupId) {
      const group = occurrencesByGroup.get(item.repeatableGroupId);
      if (group) {
        group.push(item);
      } else {
        occurrencesByGroup.set(item.repeatableGroupId, [item]);
      }
      continue;
    }

    regular.push(item);
  }

  const occurrences: ChecklistItem[] = [];
  for (const [groupId, groupItems] of occurrencesByGroup) {
    if (prototypeGroupIds.has(groupId)) {
      occurrences.push(...groupItems);
    }
  }

  return [...regular, ...occurrences];
}

/** Tolerates offline/stale payloads with no items array. */
export function getVisibleItemsForSection(section: Section): ChecklistItem[] {
  return getVisibleSectionItems(section.items ?? []);
}
